module.exports = "  <span>{{duracionAsString}}</span>"


//////////////////
// WEBPACK FOOTER
// /opt/snt/front-end-turnos/src/app/turnos/shared/countdown/countdown.component.html
// module id = uRMh
// module chunks = 2